module.exports = __webpack_public_path__ + "img/buddy_whiskers-01.072ee962.svg";